import { useMediaQuery, useOs } from "@mantine/hooks";

type UseIsMobileProps = {
  from: "os" | "media";
  mediaQuery?: string;
};
export function useIsMobile({ from, mediaQuery }: UseIsMobileProps = { from: "media" }): boolean {
  const OS = useOs();
  const isMobileFromOs = OS === "ios" || OS === "android";
  const isMobileFromMedia = useMediaQuery(mediaQuery || "(max-width: 768px)");

  if (from === "os") {
    return isMobileFromOs;
  }

  return isMobileFromMedia;
}
